{
  "dismiss": "取消"
}
